































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class NPS extends Vue {  
  /* eslint-disable no-console */
  // Circulo de carga
  private overlay = false;
  // SnackBar
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 4500;

  private encuestaLlenada = false;
  private encuesta = false;

  // Preguntas
  private cliente = this.$store.getters.idUser;
  private sexo = '';
  private edad = '';
  private estado = '';
  private mascotas = ['0','0','0','0','0','0'];
  private frase = '';
  private tiempoTrabajo = '';
  private lugarTrabajo = '';
  private mudar = '';
  private adoptoMascota = '';
  private cuatro1 = '';
  private cuatro2 = '';
  private planeaAdoptar = '';
  private tipoMascota = '';
  private motivoAdoptar = '';
  private cuidadoso = '';
  private recortar = '';
  private recortarProductos = '';
  private recortarServicios = '';
  private ajustarGasto = '';
  private ajustarGastoServicios = '';
  private medioCompra = '';
  private medioCompra6 = '';
  private preferenciaOnline = '';
  private preferenciaTienda = '';
  private rulesPreguntas = [
    (v: any) => !!v || 'Este campo es requerido',
  ];


  private validaFormulario () {
    if (this.encuesta) {
      let data = {
        cliente: this.cliente,
        sexo: this.sexo,
        edad: this.edad,
        estado: this.estado,
        mascotas: this.mascotas,
        frase: this.frase,
        tiempoTrabajo: this.tiempoTrabajo,
        lugarTrabajo: this.lugarTrabajo,
        mudar: this.mudar,
        adoptoMascota: this.adoptoMascota,
        cuatro1: this.cuatro1,
        cuatro2: this.cuatro2,
        planeaAdoptar: this.planeaAdoptar,
        tipoMascota: this.tipoMascota,
        motivoAdoptar: this.motivoAdoptar,
        cuidadoso: this.cuidadoso,
        recortar: this.recortar,
        recortarProductos: this.recortarProductos,
        recortarServicios: this.recortarServicios,
        ajustarGasto: this.ajustarGasto,
        ajustarGastoServicios: this.ajustarGastoServicios,
        medioCompra: this.medioCompra,
        medioCompra6: this.medioCompra6,
        preferenciaOnline: this.preferenciaOnline,
        preferenciaTienda: this.preferenciaTienda
      }
      this.encuesta = false;
      this.$store.dispatch('GuardaEncuesta', data)
      .then ((respuesta) => {
        if (respuesta.replyCode === 200) {
          this.createSnackBar(respuesta.replyText, 'success');
          setTimeout(function(){ window.location.href = 'https://petco.com.mx'; }, 1200);
        } else {
          this.createSnackBar('Error al guardar', 'error');
        }
      });
    }

  }

  private createSnackBar (text: string, type: string) {
    this.snackbar = true;
    this.text = text;
    this.type = type;
  }
  
}
